import { useState, useEffect } from 'react'
import { EditProposalTemplate } from 'components/common/modals/CreateProposalFromTemplateModalContainer/EditProposalTemplate'
import { useLoading } from 'hooks'
import { makeGetRequest, makePostRequest } from 'utils/api'
import { toCategories } from 'components/Admin/Organization/Templates/ProposalHtmlTemplates/serializers.js'
import { useImmer } from 'use-immer'
import s from './EditTemplates.scss'

const initialPages = [
  {
    content: []
  }
]

const EditTemplate = ({ selectedTemplate, createProposal }) => {
  const [categories, setCategories] = useState([])
  const [, withLoadingLocks] = useLoading()
  const [pageType, setPageType] = useState('letter')
  const [pages, setPages] = useImmer(initialPages)
  const [templateContent, setTemplateContent] = useState('')

  useEffect(() => {
    if (selectedTemplate.subtype === 'ideal') {
      ;(async () => {
        const result = await withLoadingLocks(
          makePostRequest('/v1/predesignedproposaltemplates', {
            id: selectedTemplate.value.id,
            thumbnailUrl: selectedTemplate.value.thumbnailUrl
          })
        )
        setTemplateContent(result)
      })()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    ;(async () => {
      if (selectedTemplate.proposalType !== 'HTML') return
      const result = await withLoadingLocks(makeGetRequest('/v1/proposaltemplates/html/sections'))
      const [sections] = toCategories(result)
      setCategories(sections)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (selectedTemplate.proposalType !== 'HTML') return
    selectedTemplate.value.content && setPages(JSON.parse(selectedTemplate.value.content))
    selectedTemplate.value.pageType && setPageType(selectedTemplate.value.pageType?.toLowerCase())
  }, [selectedTemplate, setPages])

  useEffect(() => {
    if (!templateContent || selectedTemplate.proposalType !== 'HTML') return

    setPages(JSON.parse(templateContent.content))
    setPageType(templateContent.pageType?.toLowerCase())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateContent, setPages])

  return (
    <EditProposalTemplate
      templateType={selectedTemplate?.proposalType}
      categories={categories}
      pageType={pageType}
      setPageType={setPageType}
      proposalContent={
        templateContent
          ? templateContent.content
          : selectedTemplate
            ? selectedTemplate.value.content
            : ''
      }
      pages={pages}
      saveActions={[
        {
          text: 'Generate Proposal',
          cb: (body, base64body) => {
            createProposal(body, base64body, pageType)
          },
          className: s.greenBtn,
          enabled: true
        }
      ]}
    />
  )
}

export default EditTemplate
